export enum TYPE_CARD_ENUM{
    CARD_INFO = "CARD_INFO",
    CARD_LINK = "CARD_LINK",
    CARD_TEXT= "CARD_TEXT",
    CARD_SUGGESTION="CARD_SUGGESTION",
    CARD_SPONSORED="CARD_SPONSORED",
    CARD_CONTACT="CARD_CONTACT",
    CARD_LOCATION="CARD_LOCATION"
}